import { useReducer, useCallback } from 'react';

// Helper: immutably set deep value by path
function setDeepValue(obj: any, path: string, value: any) {
  const keys = path.split(".");
  const newObj = { ...obj };
  let curr: any = newObj;

  keys.forEach((key, index) => {
    if (index === keys.length - 1) {
      curr[key] = value;
    } else {
      curr[key] = { ...(curr[key] ?? {}) };
      curr = curr[key];
    }
  });

  return newObj;
}

function reducer(state: any, action: any) {
  switch (action.type) {
    case 'INPUT_CHANGE':
      return setDeepValue(state, action.name, action.value);

    case "SET_INITIAL":
      return action.value;
    case 'RESET':
      return action.value;
    default:
      throw new Error(`Unhandled action type: ${action.type}`);
  }
}

export const useInputHelper = (initialState: any = {}) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const onDispatch = useCallback(
    (name: string) => (value: any) => {
      dispatch({ type: 'INPUT_CHANGE', name, value });
    }, []
  );
  const onSetInitial = useCallback((value: any) => {
    dispatch({ type: "SET_INITIAL", value });
  },[]);
  const handleFormReset = useCallback(() => {
    dispatch({ type: 'RESET', value: initialState });
  }, [initialState]);

  return { state, onDispatch, onSetInitial, handleFormReset };
};
